// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Bdo1","left":"StickyBox_left__2qZjq","right":"StickyBox_right__D0V7e"};